import { useEffect, useState } from 'react'

import { SkeletonRows } from '@/components/ui/skeleton'
import { TrailersTable } from '../../../../components/TrailersTable'
import { type Trailer, useTrailers } from '../../../../models/equipment'

export function TrailersTab({ orgId }: { orgId: string }) {
  const { trailers, isLoading } = useTrailers({ shouldFetchAllPages: true, orgId })
  const [selectedTrailers, setSelectedTrailers] = useState<Trailer[]>([])

  useEffect(() => {
    setSelectedTrailers(trailers)
  }, [trailers])

  if (isLoading) {
    return <SkeletonRows />
  }

  return (
    <TrailersTable
      trailers={selectedTrailers}
      setTrailers={setSelectedTrailers}
      addCtaOnTop
      searchable
      orgId={orgId}
      hideHeading
    />
  )
}
